
export const SHORTCUT_TEXT_MATERIAL_CATEGORY = `
  id
  title
  slug
`

export const SHORTCUT_TEXT_MATERIAL_THEME = `
  id
  title
  slug
`
export const SHORTCUT_TEXT_MATERIAL_TAG = `
  id
  title
  slug
`

export const SHORTCUT_TEXT_MATERIAL_TYPE = `
  id
`

export const SHORTCUT_TEXT_MATERIAL = `
  id
  title
  lead
  content
  publishedAt
  type {${SHORTCUT_TEXT_MATERIAL_TYPE}}
  category {${SHORTCUT_TEXT_MATERIAL_CATEGORY}}
  themes {${SHORTCUT_TEXT_MATERIAL_THEME}}
  tags {${SHORTCUT_TEXT_MATERIAL_TAG}}
  preview {
    url
  }
  slug
  viewsCount
`